module.exports = __webpack_public_path__ + "static/img/bg_OK.94029c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_OK.jpg
// module id = 736
// module chunks = 2